import { snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import { Dispatch } from 'react';
import { useDispatch } from 'react-redux';

export const showChangeWorkspaceViewMessage = (dispatch: Dispatch<unknown>) => (
  viewName: string
) =>
  dispatch(
    alertsUtil.openSnackbarDialog(
      snackbarTypes.CHARTS_AVAILABLE,
      `You are trying to edit a view ${viewName} from a different project. To avoid accidental changes duplicate this view to start fresh`
    )
  );
const useChangeWorkspaceViewMessage = () => {
  const dispatch = useDispatch();

  return showChangeWorkspaceViewMessage(dispatch);
};

export default useChangeWorkspaceViewMessage;
